
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/presse/[slug]",
      function () {
        return require("private-next-pages/presse/[slug].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/presse/[slug]"])
      });
    }
  